import { Box, Card, Link, Stack, Text } from '@ltvco/refresh-lib/theme';

interface SuggestedNameProps {
  name: string;
  blurb: string;
  isSurname: boolean;
}

interface SuggestedNamesProps {
  suggestedNames?: SuggestedNameProps[];
  // eslint-disable-next-line no-unused-vars
  onNameClick?: (name: string, isSurname: boolean) => void;
}

export function SuggestedNames({
  suggestedNames,
  onNameClick,
}: SuggestedNamesProps) {
  const handleNameClick = (name: string, isSurname: boolean) => {
    if (onNameClick) {
      onNameClick(name, isSurname);
    }
  };

  return (
    <Card
      variant="outlined"
      sx={{ borderRadius: '12px', p: 0, height: '100%' }}
    >
      {/* Main heading */}
      <Stack
        justifyContent="center"
        sx={{
          backgroundColor: 'background.default',
          borderBottom: '1px solid',
          borderColor: 'divider',
          px: 3,
          py: 2,
          minHeight: 56,
        }}
      >
        <Text variant="h5" fontWeight="bold" sx={{ margin: 0 }}>
          Similar Suggested Names
        </Text>
      </Stack>

      {/* Content */}
      <Box sx={{ p: 3 }}>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: 2,
          }}
        >
          {suggestedNames?.map((suggestion) => (
            <Card
              key={`${suggestion.name}-${suggestion.isSurname}`}
              variant="outlined"
              sx={{
                p: 2,
                borderRadius: '8px',
              }}
            >
              <Stack spacing={1} alignItems="flex-start">
                <Link
                  component="button"
                  variant="h6"
                  fontWeight="semibold"
                  onClick={() =>
                    handleNameClick(suggestion.name, suggestion.isSurname)
                  }
                  sx={{
                    cursor: 'pointer',
                    textAlign: 'left',
                    border: 'none',
                    background: 'none',
                    p: 0,
                    textDecoration: 'underline',
                  }}
                >
                  {suggestion.name}
                </Link>
                <Text variant="body2">{suggestion.blurb}</Text>
              </Stack>
            </Card>
          ))}
        </Box>
      </Box>
    </Card>
  );
}
